import { createFileRoute, redirect } from '@tanstack/react-router'
import { asset } from '@/lib/queries/assets'
import { decodeId, encodeId } from '@/lib/short-uuid'
import { AssetDetailPage } from '@/features/assets/detail'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/assets/$assetId'
)({
  params: {
    parse: (rawParams: { assetId: string }) => {
      try {
        return { assetId: decodeId(rawParams.assetId) }
      } catch {
        return { assetId: rawParams.assetId }
      }
    },
    stringify: (params: { assetId: string }) => ({
      assetId: encodeId(params.assetId),
    }),
  },
  loader: async ({ context, params }) => {
    const { queryClient } = context

    try {
      const data = await queryClient.query(asset.findOne(params.assetId))

      // Organisation-level assets open from any workspace of that org.
      const inWorkspace = data?.workspace_id === params.workspaceId
      const orgLevel =
        data?.workspace_id === null && data?.org_id === params.orgId
      if (!data || !(inWorkspace || orgLevel)) {
        throw new Error('Invalid asset')
      }
    } catch {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/assets',
        params: { orgId: params.orgId, workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
  component: AssetDetailPage,
})
